module.exports = __webpack_public_path__ + "img/23.82c785b3.jpg";